import { Button } from '@kizen/kds/Button';
import { NavIcon } from '__components/Kizen/Icon';

export const HeaderPreview = (props: any) => {
  const { columns = [] } = props;

  return (
    <div className="kds kds-expanding-scrollbar flex border-1 border-solid border-border-medium-light h-[50px] items-center gap-x-spacer-20 px-spacer-20">
      {columns.map((column: any, index: number) => {
        return (
          <div key={index} className="kds flex gap-x-spacer-20 items-center">
            <Button
              leftIcon={column.icon || 'bars-light'}
              variant="text"
              color="inherit"
              size="small"
              preserveCase
              hoverColor={column.color}
              renderIcon={(props) => (
                <NavIcon
                  {...props}
                  size="1x"
                  style={{
                    color: 'inherit',
                    fontSize: '14px',
                    paddingRight: '8px',
                  }}
                />
              )}
            >
              {column.label || column.displayName}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
